var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.75H1.74998C1.10831 0.75 0.583313 1.275 0.583313 1.91667V8.91667C0.583313 9.55833 1.10831 10.0833 1.74998 10.0833H4.66665V11.25H9.33331V10.0833H12.25C12.8916 10.0833 13.4108 9.55833 13.4108 8.91667L13.4166 1.91667C13.4166 1.275 12.8916 0.75 12.25 0.75ZM12.25 8.91667H1.74998V1.91667H12.25V8.91667ZM11.0833 3.66667H4.66665V4.83333H11.0833V3.66667ZM11.0833 6H4.66665V7.16667H11.0833V6ZM4.08331 3.66667H2.91665V4.83333H4.08331V3.66667ZM4.08331 6H2.91665V7.16667H4.08331V6Z",
    fill: "#1F8598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.e03662857377930ce0769f664c8ed1fd.svg";
export { ForwardRef as ReactComponent };